<div class="select-overlay2-wrapper">
  <button type="button"
          #trigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          (click)="openOverlay()"
          class="mimic-mat-select-field col__ {{buttonClass}}"
          [ngClass]="triggerButtonClass">
    {{getTriggerText}}
    <div class="mat-select-arrow-wrapper">
      <div class="mat-select-arrow"></div>
    </div>
  </button>

  <!-- @JARROD: Check out the API here for the overlay
        I think you will find most of the css and display behavior
        can be modified using the directives.  You may want to play around with it,
        unfortunately there are not many great examples.
        https://material.angular.io/cdk/overlay/api#CdkConnectedOverlay

        Some interesting inputs look like: [cdkConnectedOverlayGrowAfterOpen]="true"
        cdkConnectedOverlayTransformOriginOn
        [cdkConnectedOverlayFlexibleDimensions]="true"

        Also of note, the default position strategy determines to place the
        overlay above or below the trigger based upon the height. However,
        we have a variable height here, and setting a min height too high
        makes the position weird when there are fewer search elements. I think
        this could be fixed with some combination of the cdk directives

        [cdkConnectedOverlayMinHeight]="100"
    -->

  <!-- Note: giving this a backdrop, to close the overlay using backdropClick
            using overlayOutsideClick will cause the overlay to be closed on nested menus.
            You can apply a custom class for the bankdrop to make transparent using
            [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'""
        -->
  <ng-template cdkConnectedOverlay
               (backdropClick)="closeOverlay()"
               (detach)="closeOverlay()"
               [cdkConnectedOverlayPush]="true"
               [cdkConnectedOverlayHasBackdrop]="true"
               [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
               [cdkConnectedOverlayHeight]="400"
               [cdkConnectedOverlayMinHeight]="'400px'"
               [cdkConnectedOverlayOrigin]="trigger"
               [cdkConnectedOverlayWidth]="triggerWidth$ | async"
               [cdkConnectedOverlayMinWidth]="'300px'"
               [cdkConnectedOverlayOpen]="isOpen">
    <div class="select-overlay2 adv-resp-selector adv-resp-selector--query-builder">
      <div class="select-overlay2 select-overlay2__content select-info">
        <div class="select-info__controls2 p-0100 pt-0075 pb-0050">
          <button type="button"
                  class="ab-overlay-close-button"
                  (click)="closeOverlay()">
            <span><i class="fal fa-times"></i></span>
          </button>
          <div class="color--gray--008">Showing responses for:</div>

          <div class="menu-options menu-options--2-btn">
            <ng-container *ngIf="targetType !== 'CalendarEventType'">

              <button mat-button
                      [disabled]="targetTypeId"
                      #selectTypeMenuTrigger="matMenuTrigger"
                      [matMenuTriggerFor]="selectTypeMenu"
                      class="ab-mat-button mt-0050 mr-0050"
                      [disableRipple]="true">
                <app-type-name-label [type]="selectedType"
                                     *ngIf="selectedType"></app-type-name-label>
                <span *ngIf="!selectedType">
                  {{emptyTypeTriggerText}}
                </span>
                <button mat-icon-button
                        *ngIf="selectedType && !targetTypeId"
                        (click)="onSelectedTypedChanged(null)">
                  <mat-icon fontSet="fal"
                            fontIcon="fa-times"></mat-icon>
                </button>
              </button>
              <mat-menu #selectTypeMenu="matMenu"
                        class="ab-menu-panel">
                <button mat-menu-item
                        (click)="onSelectedTypedChanged(null, selectTypeMenuTrigger)"
                        [ngClass]="{active: selectedType == null}">
                  {{emptyTypeTriggerText}}
                </button>
                <button mat-menu-item
                        *ngFor="let option of typeOptions"
                        (click)="onSelectedTypedChanged(option, selectTypeMenuTrigger)"
                        [ngClass]="{active: selectedType && (option.id === selectedType.id)}">
                  <app-type-name-label [type]="option"></app-type-name-label>
                </button>
              </mat-menu>
            </ng-container>

            <app-field-search-select [campaignId]="campaignId"
                                     [hideUniversal]="hideUniversal"
                                     [tagTypes]="tagTypes"
                                     [targetType]="targetType"
                                     [hideReadonly]="hideReadonly"
                                     [targetTypeId]="selectedType?.id"
                                     [selectedField]="selectedField"
                                     (selectedFieldChange)="selectedFieldChanged($event)"
                                     [triggerClass]="'ab-mimic-mat-button mt-0050'"
                                     [dropdownClass]="'ab-qb-dropdown'">
            </app-field-search-select>
          </div>

        </div>
        <app-response-search class="select-info__options"
                             [allowSelectAll]="allowSelectAll && multiple"
                             (allSelected)="onAllTagsSelected($event)"
                             [selectedResponses]="selectedResponses"
                             [tagTypes]="tagTypes"
                             [orderByTargetName]="true"
                             [hideUniversal]="hideUniversal"
                             [hideReadonly]="hideReadonly"
                             [(selectAllLoading)]="selectAllLoading"
                             [tagCategoryIds]="selectedFieldIds"
                             [targetType]="targetType"
                             [targetTypeId]="selectedType?.id"
                             [limitToCampaignId]="campaignId"
                             [isAdvancedResponseSelector]="true">

          <!-- Template is displayed while we are loading all tags that were selected-->
          <!-- `app-response-search` already has loading text/animation; the following isn't needed (for now) -->
          <ng-container *ngIf="selectAllLoading">
            <!--<div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <strong class="p-0050 pl-0100 d-block txt-14">Selecting All Results....</strong>
            </div>-->
          </ng-container>



          <!-- Template for each response-->
          <ng-container *responseItemTmpl="let response = response; let i = i">
            <!-- Template for multi select-->
            <mat-checkbox *ngIf="multiple"
                          [checked]="isResponseSelected(response.id)"
                          [indeterminate]="selectAllPending"
                          (change)="onResponseCheckboxChanged($event, response)"
                          class="si-option d-block w-100 p-0">
              <div class="text">
                <div class="text__label">{{response.name}}</div>
                <div class="text__desc">
                  <ng-container *ngIf="targetType !== 'CalendarEventType'">
                    <app-type-name-label [type]="response.targetType"></app-type-name-label>
                    &rsaquo;
                  </ng-container>
                  <ng-container>
                    <i class="fal fa-solar-system color--purple"
                       matTooltip="This is a universal field; responses belonging to this field are available across all campaigns for which this field is enabled."
                       *ngIf="response.isUniversal"></i>
                  </ng-container>
                  {{response.category.name}}
                </div>
              </div>
            </mat-checkbox>
            <!-- /Template for multi select-->

            <!-- Template for single select-->
            <div class="text d-block w-100 p-0025 pl-0075"
                 *ngIf="!multiple"
                 (click)="onResponseSelected(response)">
              <div class="text__label">{{response.name}}</div>
              <div class="text__desc">
                <ng-container *ngIf="targetType !== 'CalendarEventType'">
                  <app-type-name-label [type]="response.targetType"></app-type-name-label>
                  &rsaquo;
                </ng-container>
                {{response.category.name}}
              </div>

            </div>
            <!-- Template for single select-->
          </ng-container>
        </app-response-search>
      </div>
    </div>
  </ng-template>
</div>
